import React, { useState, useEffect } from "react";
import { useStoreon } from "storeon/react";
import { useHistory } from "react-router-dom";
import themeStyles from "../../shared/styles/theme/theme-styles.module.scss";
import styles from "./styles.module.scss";
import {
  LOAD_SETTINGS_TABLES,
  SAVE_SETTINGS_TABLES,
} from "../../store/tableSettings";
import { LOAD_GENERAL_SETTINGS } from "../../store/generalSettings";
import TableFrame from "../components/tablesFrame/tableFrame";
import TableLastFrame from "../components/tablesFrame/tableLastFrame";
import TextEditor from "../components/textEditor/textEditor";
import BackgroundColor from "../components/backgroungColor/backgroundColor";
import img from "../../shared/images/settings-background.jpg";

const laneThrow = {
  activePlayer: false,
  active_player: false,
  game: 0,
  lane: 0,
  playerHcp: 0,
  playerName: "",
  playerNumber: 0,
  scoreCompletedGames: 0,
  teamHcp: 0,
  teamName: "",
  pins: [],
  scores: [],
  speed: [],
  throws: [],
  player_number: 0,
  maxScore: 0,
};

const playersPreview = new Array(2)
  .fill("")
  .map((e, index) => ({ ...laneThrow, displayName: `Player ${index + 1}` }));

export const TableSettingsForm = ({
  tableStyles,
  onChangeColor,
  onChangeFontSize,
  onChangeFontWeight,
}) => (
  <div className={styles.bodyContainer}>
    <div className={styles.containerSettings}>
      <div className={styles.playerSettings}>
        <div className={styles.bodySettings}>
          <TextEditor
            playerNameStyles={tableStyles.oddRows}
            handleChangeComplete={onChangeColor("oddRows.color")}
            handleChangeBackground={onChangeColor("oddRows.background")}
            handleOnSelect={onChangeFontSize("oddRows")}
            selectBold={onChangeFontWeight("oddRows")}
            background
            backgroundLabel="Odd Rows Background"
            stylesLabel="Odd Rows Styles"
            fontWeight
          />
        </div>
        <div className={styles.bodySettings}>
          <TextEditor
            playerNameStyles={tableStyles.maxScore}
            handleChangeComplete={onChangeColor("maxScore.color")}
            handleChangeBackground={onChangeColor("maxScore.background")}
            handleOnSelect={onChangeFontSize("maxScore")}
            selectBold={onChangeFontWeight("maxScore")}
            background
            backgroundLabel="Max Score Background"
            stylesLabel="Max Score Styles"
            fontWeight
          />
        </div>
        <div className={styles.bodySettings}>
          <TextEditor
            playerNameStyles={tableStyles.evenRows}
            handleChangeComplete={onChangeColor("evenRows.color")}
            handleChangeBackground={onChangeColor("evenRows.background")}
            handleOnSelect={onChangeFontSize("evenRows")}
            selectBold={onChangeFontWeight("evenRows")}
            background
            backgroundLabel="Even Rows Background"
            stylesLabel="Even Rows Styles"
            fontWeight
          />
        </div>
        <div className={styles.bodySettings}>
          <TextEditor
            playerNameStyles={tableStyles.frameContainer}
            handleChangeComplete={onChangeColor("frameContainer.color")}
            handleChangeBackground={onChangeColor("frameContainer.background")}
            handleOnSelect={onChangeFontSize("frameContainer")}
            selectBold={onChangeFontWeight("frameContainer")}
            background
            backgroundLabel="Frames Background"
            stylesLabel="Frames Styles"
            fontWeight
          />
        </div>
        <div className={styles.bodySettings}>
          <div className={styles.backgroundInputContainer}>
            <span>Section Container Background</span>

            <div className={styles.backgroundInput}>
              <BackgroundColor
                handleChange={onChangeColor("sectionContainerBackground")}
                background={tableStyles.sectionContainerBackground}
                skew
              />
            </div>
          </div>
        </div>
      </div>
      <div className={styles.playerSettings}>
        <div className={styles.bodySettings}>
          <div className={styles.containerTable}>
            <TableFrame players={playersPreview} tableStyles={tableStyles} />
          </div>
          <div className={styles.containerTable}>
            <TableFrame
              players={playersPreview}
              showLow={true}
              tableStyles={tableStyles}
            />
          </div>
          <div className={styles.containerTable}>
            <TableLastFrame
              players={playersPreview}
              tableStyles={tableStyles}
            />
          </div>
        </div>
      </div>
    </div>
  </div>
);

const TableSettings = () => {
  const history = useHistory();
  const { dispatch, tableSettings, auth } = useStoreon(
    "tableSettings",
    "generalSettings",
    "auth",
  );
  const [tableStyles, setTableStyles] = useState(tableSettings);

  useEffect(() => {
    dispatch(LOAD_GENERAL_SETTINGS, { history });
    dispatch(LOAD_SETTINGS_TABLES, auth);
  }, [auth, dispatch]);

  useEffect(() => {
    setTableStyles(tableSettings);
  }, [tableSettings]);

  const onChangeColor = (typeKey) => (color) => {
    const [type, key] = typeKey.split(".");
    setTableStyles({
      ...tableStyles,
      [type]: key ? { ...tableStyles[type], [key]: color.hex } : color.hex,
    });
  };

  const onChangeFontSize = (type) => (evt) => {
    setTableStyles({
      ...tableStyles,
      [type]: { ...tableStyles[type], fontSize: evt.target.value },
    });
  };

  const onChangeFontWeight = (type) => (value) => {
    setTableStyles({
      ...tableStyles,
      [type]: { ...tableStyles[type], fontWeight: value ? "700" : "normal" },
    });
  };

  const onSaveHandler = () => {
    try {
      dispatch(SAVE_SETTINGS_TABLES, {
        data: tableStyles,
        history,
      });
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className={styles.overallContainer}>
      <div className={styles.lines}></div>

      <TableSettingsForm
        tableStyles={tableStyles}
        onChangeColor={onChangeColor}
        onChangeFontSize={onChangeFontSize}
        onChangeFontWeight={onChangeFontWeight}
      />

      <div
        className={styles.bodyContainer}
        style={{ padding: "0px 20px 67px" }}
      >
        <button
          className={themeStyles.btnPrimaryLT}
          onClick={onSaveHandler}
          style={{ width: 346 }}
        >
          Save
        </button>
      </div>
      <div
        className={styles.backgroundImage}
        style={{
          backgroundImage: `url(${img})`,
        }}
      ></div>
    </div>
  );
};
export default TableSettings;
